import React from 'react';
import Img from 'gatsby-image';
import PropTypes from 'prop-types';

// styles
import './image.scss';

export const Image = ({ fixed, fluid, fadeIn, className, placeholderClassName, position, ...props }) => {
  if(Object.keys(fixed).length !== 0 && fixed.constructor === Object){
    return(
      <Img
        fadeIn={fadeIn}
        fixed={fixed}
        className={className}
        placeholderClassName={placeholderClassName}
        style={{ position }}
        {...props}
      />
    )
  }
  return (
    <Img
      fadeIn={fadeIn}
      fluid={fluid}
      className={className}
      placeholderClassName={placeholderClassName}
      style={{ position }}
      {...props}
    />
  );
};

Image.defaultProps = {
  fadeIn: true,
  placeholderClassName: 'gatsby-placeholder-image',
  className: '',
  fluid: {},
  fixed: {},
  position: 'relative'
};

Image.propTypes = {
  fadeIn: PropTypes.bool,
  placeholderClassName: PropTypes.string,
  className: PropTypes.string,
  fluid: PropTypes.object,
  fixed: PropTypes.object
};
